class SearchTab {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-scope="search"]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
        this.hash = window.location.hash;
        if (this.hash) {
            this.$scope.find(this.hash).click();
        }
    }
}

export default new SearchTab;
